export default __webpack_public_path__ + "static/media/Coil of Tiandal.f7caf225.jpg";